import { useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup";

import Button from '@/components/Button'
import Toast from '@/components/Toast'
import { AuthContext } from '@/contexts/AuthContext'
import { ModalContext } from '@/contexts/ModalContext'
import resolveErrors from '@/utils/resolveErrors';
import { toast } from 'react-toastify';
import { CogIcon } from '@heroicons/react/solid';
import { getFunctions, httpsCallable } from "firebase/functions";

export default function ForgotPassword() {
  const { recoverPassword } = useContext(AuthContext)
  const { closeModal } = useContext(ModalContext)
  const [serverErrors, setServerErrors] = useState(null)
  const functions = getFunctions()
  const generatePasswordResetLink = httpsCallable(functions, 'generatePasswordResetLink');

  const schema = yup.object().shape({
    email: yup.string().email().required(),
  });

  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmitHandler = async ({ email }) => {
    try {
      await generatePasswordResetLink({ email })
      closeModal()
      toast(<Toast icon={<CogIcon className="h-6 w-6 text-gray-300" />} text={`We have sent a reset password link to ${email}`} />)
    } catch (err) {
      console.log(err)
      setServerErrors(resolveErrors(err))
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)} className="mt-6 grid gap-4 text-sm">
      <div>
        <label className="block mb-1 font-medium">Email</label>
        <input {...register('email')} type="email" placeholder="john@example.com" required className={errors?.email ? '!border-red-500' : ''} />
      </div>
      {serverErrors && <p className="text-xs text-red-500 font-medium">{serverErrors}</p>}
      <Button modifier="primary" type="submit" className="py-3">
        {isSubmitting ? (
          <span className="flex items-center justify-center">
            Submitting
            <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </span>
        ) : (
          <span>Recover Password</span>
        )}
      </Button>
    </form>
  )
}